/**
 * 预告类型
 */
export enum AnnouncementType {
  /**
   * 竞价预告
   */
  APPLY = 0,

  /**
   * 成交公告
   */
  TRANSACTION = 1
}
